<template>
  <lf-card class="mb-8 max-w-(--breakpoint-md) py-6">
    <template v-slot>
      <loader :isLoading="isSubmitting" />
      <form @submit.prevent="onSubmit">
        <div class="my-2 space-y-2">
          <lf-h3>{{ $t("ORGANIZATION.CLOSE_API.TITLE") }}</lf-h3>
          <span v-if="!(isFundingAdvisor || isClientFundingAdvisor)">
            {{ $t("ORGANIZATION.CLOSE_API.DESCRIPTION") }}
          </span>
          <lf-input
            :placeholder="$t('ORGANIZATION.CLOSE_API.API_KEY')"
            :value="closeio_api_key"
            name="api_key"
            type="text"
            class="py-3"
            :disabled="isFundingAdvisor || isClientFundingAdvisor"
          />
          <access-control :roles="NOT_FA_ROLE_GROUP">
            <div
              class="flex min-w-full items-center justify-end border-t pt-6 pr-5"
            >
              <primary-button type="submit" :disabled="isSubmitting">
                {{ $t("COMMON.SAVE_CHANGES") }}
              </primary-button>
            </div>
          </access-control>
        </div>
      </form>
    </template>
  </lf-card>
</template>

<script>
import { computed, reactive } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

import { toFormValidator } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { z } from "zod";

import { NOT_FA_ROLE_GROUP } from "@/helpers/constants";
import { dispatchAction } from "@/helpers/vee-validate";
import { useAuth } from "@/hooks/auth";

import LfCard from "@/components/ui/LfCard.vue";

export default {
  components: {
    LfCard,
  },
  setup() {
    const { t } = useI18n();
    const { getters } = useStore();
    const { isFundingAdvisor, isClientFundingAdvisor } = useAuth();
    const closeio_api_key = computed(
      () => getters["clients/active"].closeio_api_key
    );

    const validationSchema = z.object({
      api_key: z.string().min(1, t("COMMON.VALIDATION.API_KEY_REQUIRED")),
    });

    const initialValues = reactive({
      api_key: closeio_api_key.value ?? "",
    });

    const { handleSubmit, isSubmitting } = useForm({
      initialValues,
      validationSchema: toFormValidator(validationSchema),
    });

    const onSubmit = handleSubmit(async (values, actions) => {
      if (!values.api_key) {
        delete values.api_key;
      }
      try {
        await dispatchAction(values, actions, "clients/updateCloseApiKey");
      } catch {
        //
      }
    });

    return {
      onSubmit,
      isSubmitting,
      closeio_api_key,
      NOT_FA_ROLE_GROUP,
      isFundingAdvisor,
      isClientFundingAdvisor,
    };
  },
};
</script>
